import { Style, Stroke } from 'ol/style';

export default new Style({
	stroke: new Stroke({
		color: '#0047C3',
		width: 1.2,
	})
})